import { Component, ChangeDetectionStrategy } from '@angular/core';

import { AiLoaderComponent } from 'src/shared/components/ai-loader/ai-loader.component';

@Component({
  selector: 'tidy-ai-loader-circle',
  templateUrl: './ai-loader-circle.component.html',
  styleUrls: ['./ai-loader-circle.component.scss'],
  standalone: true,
  imports: [AiLoaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiLoaderCircleComponent {}
